module.exports = __webpack_public_path__ + "components/home-header/static/header-1--medium-ab96f018fe44c1bc43ddf3dac7024e7d.jpg";